import React, {Component} from 'react';
import {Link} from 'react-router';

class NavBar extends Component {

    render() {
        let network = this.props.network;

        return (
            <ul className="account-settings">
                <li>
                    <Link to={`/${network}/help/faq`} activeClassName="active-tab">
                        <span>FAQs</span>
                    </Link>
                </li>

                <li>
                    <Link to={`/help/contact`} activeClassName="active-tab">
                        <span>Contact</span>
                    </Link>
                </li>
            </ul>
        )
    }
}

export default NavBar;


// WEBPACK FOOTER //
// src/client/components/site/features/help/common/NavBar.js